import React from 'react';
import { JcCommonProps, JcSize, JcUtils } from '../utils/JcUtils';

export interface JcImageProps extends JcCommonProps {
  readonly size: JcSize;
  readonly url: string;
  readonly alt: string;
  readonly circle?: boolean;
}

export const JcImage: React.FunctionComponent<JcImageProps> = (props: JcImageProps) => {
  const { size, url, alt, circle } = props;
  const commonProps = JcUtils.commonProps(props, [
    "jc-image",
    size !== JcSize.NONE && ("jc-image-size-" + size),
    circle && "jc-image-circle",
  ]);

  return <img {...commonProps} alt={alt} src={url} />;
}